import _ from 'underscore'
import ClassicBridge from '../next/ClassicBridge'

export function collectCustomFieldValues(target) {
    return _.pick(target, (value, key) => ClassicBridge.isCustomField(key))
}


// WEBPACK FOOTER //
// ./web/js/customFields/utils.js